import { render } from "./AccessDialog.vue?vue&type=template&id=043c12f3&ts=true"
import script from "./AccessDialog.vue?vue&type=script&lang=ts"
export * from "./AccessDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__